import type { ToFolderQuantityColumns } from "./types";

// Built from the grid's plans, so a folder without one of them gets no column
export const toFolderQuantityColumns: ToFolderQuantityColumns = ({
  planColumns,
  noFolderLabel,
}) => {
  // The null key holds the plans at the root
  const folderById = new Map<
    number | null,
    { name: string; floorPlanIds: number[] }
  >();

  for (const { floorPlanId, folderId, folderName } of planColumns) {
    const folder = folderById.get(folderId);
    if (folder !== undefined) {
      folder.floorPlanIds.push(floorPlanId);
      continue;
    }
    folderById.set(folderId, {
      name: folderName ?? noFolderLabel,
      floorPlanIds: [floorPlanId],
    });
  }

  return (
    [...folderById]
      // "No folder" last, so the columns add up to the row total; numeric like the sidebar
      .sort(([firstId, firstFolder], [secondId, secondFolder]) => {
        if (firstId === null) return 1;
        if (secondId === null) return -1;
        return firstFolder.name.localeCompare(secondFolder.name, undefined, {
          numeric: true,
        });
      })
      .map(([folderId, folder]) => ({
        id: folderId === null ? "folder_none" : `folder_${folderId}`,
        header: `${folder.name} (${folder.floorPlanIds.length})`,
        floorPlanIds: folder.floorPlanIds,
      }))
  );
};
